import React from "react";
import {Button, Modal} from "react-bootstrap";
import {copyToClipboard} from "../../../utils/general";

const DOC_LINK = 'https://tiiny.host/documentation/custom-domain/add-custom-domain/connect';

function Record({name, value}) {
  return <div className="cname-record mt-2 p-2">
    <table>
      <tr>
        <td className="flex bold pe-2">Name</td>
        <td>
          <span className="text-break grey">{name}</span>
          <button className="copy-button ms-2" onClick={() => copyToClipboard(name)}>
            <img height={15} src="assets/icons/copy.png" />
          </button>
        </td>
      </tr>
      <tr>
        <td className="flex bold pe-2">Value:</td>
        <td>
          <span className="text-break grey">{value}</span>
          <button className="copy-button ms-2" onClick={() => copyToClipboard(value)}>
            <img height={15} src="assets/icons/copy.png" />
          </button>
        </td>
      </tr>
    </table>
  </div>
}

const Details = ({ onClose, show, cfRecord, certRecord }) => {
  return <Modal
    show={show}
    onHide={onClose}
    aria-labelledby="contained-modal-title-vcenter"
    centered
  >
    <div className="m-4">
      <h3>Connecting your domain</h3>
      <a target="_blank" href={DOC_LINK}>
        <Button variant="outline-secondary" size="sm">View documentation</Button>
      </a>
      <p className="grey mt-4">The following CNAME records should have been added to your DNS settings:</p>
      <Record name={certRecord?.name} value={certRecord?.value} />
      <Record name="*" value={cfRecord} />
    </div>
    <Button
      className="action-btn round-top-0"
      onClick={onClose}
    >
      Done
    </Button>
  </Modal>
}

export default Details;